module.exports = __webpack_public_path__ + "static/media/AutoCAD LT.bd5cef88.png";